import React, { useEffect, useState } from "react";
import { Box, Fade, Button, Typography, Snackbar, Alert } from "@mui/material";

import { Save, Check, Close } from "@mui/icons-material";

import { DiaCard } from "../components/nuevaCeremonia/DiaCard";
import { AcolitosContext } from "../../context/AcolitosContext";
import { getAcolitosActivos } from "../../helpers/acolitos";
import { Loading } from "../../common/components";
import { CustomModal } from "../../common/components/CustomModal";
import { postCeremonia } from "../../helpers/ceremonias";

export const NuevaCeremonia = () => {
  //nombre de la pestaña
  document.title = "Nueva Ceremonia";

  const [acolitos, setAcolitos] = useState([]);
  const [loadingAcolitos, setLoadingAcolitos] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [showNextCeremonia, setshowNextCeremonia] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [errorAlert, setErrorAlert] = useState(
    "Error: faltan campos por llenar."
  );

  useEffect(() => {
    //Obtener acólitos
    getAcolitosActivos().then((a) => {
      setAcolitos(a);
      setLoadingAcolitos(false);
    });
  }, []);

  const rolBase = [
    {
      id_dia: 1,
      clase: 0,
      color_ornamentos: "",
      festividad: "",
      fecha: "",
      ceremonias: [
        {
          id_ceremonia: 1,
          tipo_misa: "",
          horario: "",
          acolitos: [
            {
              id: 1,
              id_acolito: 0,
              nombre: "",
              id_puesto: 0,
              puesto: "",
            },
          ],
        },
      ],
    },
  ];

  const [rol, setRol] = useState(rolBase);

  // Función para validar que todos los campos estén llenos
  const validarCampos = () => {
    let valido = true;

    rol.forEach((dia) => {
      if (
        dia.fecha === "" ||
        dia.fecha === null ||
        dia.fecha === "Invalid Date" ||
        dia.festividad === "" ||
        dia.color_ornamentos === "" ||
        dia.clase === 0
      ) {
        valido = false;
      }

      dia.ceremonias.forEach((ceremonia) => {
        if (
          ceremonia.horario === null ||
          ceremonia.horario === "" ||
          ceremonia.tipo_misa === "" ||
          ceremonia.acolitos.length === 0 ||
          ceremonia.acolitos.some(
            (acolito) =>
              acolito.id_acolito === 0 ||
              acolito.id_acolito === null ||
              acolito.id_puesto === 0 ||
              acolito.id_puesto === null
          )
        ) {
          valido = false;
        }
      });
    });

    return valido;
  };

  const guardarRol = async () => {
    setGuardando(true);
    if (validarCampos()) {
      const resp = await postCeremonia(rol);
      if (resp) {
        setShowModal(false);
        setshowNextCeremonia(true);
      } else {
        setErrorAlert("Error al guardar el rol: Revisa tu conexión a internet");
        setShowModal(false);
        setShowAlert(true);
        setGuardando(false);
      }
    } else {
      setShowModal(false);
      setShowAlert(true);
      setGuardando(false);
    }
  };

  const nuevoRol = () => {
    window.location.reload();
  };

  //Mostrar cargando si no se han cargado los acolitos
  if (loadingAcolitos) {
    return <Loading texto="Obteniendo acólitos" />;
  }

  return (
    <div>
      <AcolitosContext.Provider value={acolitos}>
        <Fade in={true} timeout={1000}>
          <Box sx={style.modal}>
            <Typography
              id="transition-modal-title"
              variant="h4"
              sx={style.modal_title}
              color="primary"
              fontWeight={900}
            >
              NUEVA CEREMONIA
            </Typography>
            <Typography
              id="transition-modal-title"
              variant="body1"
              color="secondary"
              // fontWeight={900}
              textAlign={"center"}
              sx={{ mt: 2 }}
            >
              Los acólitos asignados, serán notificados por correo y whatsapp el
              día anterior a la ceremonia.
            </Typography>
            {rol.map((dia) => (
              <DiaCard key={dia.id_dia} dia={dia} setRol={setRol} />
            ))}
            <div style={{ position: "fixed", bottom: 20, right: 20 }}>
              <Button
                startIcon={<Save style={{ fontSize: 20 }} />}
                sx={{
                  borderRadius: 2,
                  boxShadow: 8,
                  transition: "transform 0.3s",
                  bgcolor: "white",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                  fontSize: 20,
                  fontWeight: 900,
                  padding: "10px 20px",
                }}
                onClick={() => setShowModal(true)}
              >
                Guardar
              </Button>
            </div>
          </Box>
        </Fade>

        {/* Modal para preguntar si quiere agregar el siguiente rol */}
        <CustomModal
          open={showNextCeremonia}
          title="¡Ceremonia guardada!"
          text="¿Desea agregar otra ceremonia?"
          txtBtn1="Sí"
          txtBtn2="No"
          funBtn1={() => nuevoRol()}
          funBtn2={() => (window.location.href = "/ceremonias")}
          iconBtn1={<Check />}
          iconBtn2={<Close />}
        />
        {/* Modal para confirmar que deseamos guardar los cambios */}
        {
          <CustomModal
            open={showModal}
            funBtn1={guardarRol}
            funBtn2={() => setShowModal(false)}
            btnDisabled={guardando}
          />
        }
        {/* Alerta de error */}
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={() => setShowAlert(false)}
        >
          <Alert
            onClose={() => setShowAlert(false)}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errorAlert}
          </Alert>
        </Snackbar>
      </AcolitosContext.Provider>
    </div>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
  },
};
